import raffles from '../raffles.json';

const useRaffles = (key) => {
  return key ? raffles[key] : raffles;
};

export default useRaffles;
